import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./main.css";
import packageJson from '../package.json'
import * as Sentry from "@sentry/react";
import { loadRuntimeConfig } from "./utils/runtimeConfig.ts";

const bootstrap = async () => {
    // Load runtime configuration first (async in production)
    const config = await loadRuntimeConfig();

    // Normalize environment name to match infrastructure naming convention
    const mode = import.meta.env.MODE;
    const environmentName = mode === 'live'
        ? 'Production'
        : mode.charAt(0).toUpperCase() + mode.slice(1);

    // Initialize Sentry with runtime configuration
    const sentryEnabled = config.VITE_SENTRY_ENABLED === 'true';
    const isProduction = environmentName === 'Production';

    Sentry.init({
        dsn: 'https://667fe8925030af350ae3bcdd562ab996@o4508097375764480.ingest.de.sentry.io/4509508218454096',
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        enabled: sentryEnabled,
        debug: !isProduction,
        release: `${packageJson.name}@${packageJson.version}`,
        environment: environmentName,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.25,
    });

    if (
        process.env.NODE_ENV === 'development' &&
        import.meta.env.VITE_USE_MIRAGE === 'true'
    ) {
        const { startMirage } = await import('./../mocks/mirage')
        startMirage({ environment: 'development' })
    }

    createRoot(document.getElementById("root")!).render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}

bootstrap()